(() => {
  const STATE = new WeakMap();

  function getState(root) {
    let st = STATE.get(root);
    if (!st) {
      st = { page: 1, buffer: [], exhausted: false, loading: false };
      STATE.set(root, st);
    }
    return st;
  }

  function getPerPage(root) {
    const n = Number(root.dataset.perPage || "12");
    return Number.isFinite(n) && n > 0 ? n : 12;
  }

  function setLoading(root, isLoading) {
    const btn = root.querySelector("[data-load-more]");
    const spinner = root.querySelector("[data-spinner]");
    if (btn) btn.disabled = isLoading;
    if (spinner) spinner.hidden = !isLoading;
  }

  function hideButton(root) {
    const btn = root.querySelector("[data-load-more]");
    if (btn) btn.hidden = true;
  }

  function showButton(root) {
    const btn = root.querySelector("[data-load-more]");
    if (btn) btn.hidden = false;
  }

  function getGrid(root) {
    return root.querySelector("[data-product-grid]");
  }

  function extractItemsFromHtml(htmlText) {
    const doc = new DOMParser().parseFromString(htmlText, "text/html");
    const newGrid =
      doc.querySelector("[data-product-grid]") ||
      doc.querySelector("ul.product-grid") ||
      doc.querySelector("ul.grid.product-grid");

    if (!newGrid) return [];
    let items = Array.from(newGrid.querySelectorAll("li.grid__item"));
    if (items.length === 0) items = Array.from(newGrid.querySelectorAll("li"));
    return items;
  }

  async function fetchNextPageIntoBuffer(root) {
    const st = getState(root);
    if (st.exhausted || st.loading) return 0;

    const collectionUrl = root.dataset.collectionUrl;
    if (!collectionUrl) {
      st.exhausted = true;
      hideButton(root);
      return 0;
    }

    st.loading = true;
    try {
      const nextPage = st.page + 1; // 初回表示は page=1 相当
      const url = `${collectionUrl}?page=${nextPage}`;

      const res = await fetch(url, { credentials: "same-origin" });
      if (!res.ok) throw new Error(`Fetch failed: ${res.status}`);

      const html = await res.text();
      const items = extractItemsFromHtml(html);

      if (items.length === 0) {
        st.exhausted = true;
        hideButton(root);
        return 0;
      }

      st.buffer.push(...items);
      st.page = nextPage;
      return items.length;
    } catch (e) {
      console.error(e);
      return 0;
    } finally {
      st.loading = false;
    }
  }

  function appendFromBuffer(root) {
    const st = getState(root);
    const grid = getGrid(root);
    if (!grid) return 0;

    const perPage = getPerPage(root);
    const toAppend = st.buffer.splice(0, perPage);
    toAppend.forEach((li) => grid.appendChild(li));
    return toAppend.length;
  }

  async function peekAndMaybeHide(root) {
    // バッファが空なら次ページを一度だけ覗き見して、無ければ消す
    const st = getState(root);
    if (st.exhausted) {
      hideButton(root);
      return;
    }

    if (st.buffer.length > 0) {
      showButton(root);
      return;
    }

    const got = await fetchNextPageIntoBuffer(root);
    if (got === 0 && st.buffer.length === 0) {
      st.exhausted = true;
      hideButton(root);
    } else {
      // 覗き見で取れた分は次回のクリックで使う
      showButton(root);
    }
  }

  async function loadMore(root) {
    const st = getState(root);
    if (st.exhausted) {
      hideButton(root);
      return;
    }

    const perPage = getPerPage(root);

    // 足りなければ取りに行く（最大ガード）
    let guard = 0;
    while (st.buffer.length < perPage && !st.exhausted && guard < 5) {
      guard++;
      const got = await fetchNextPageIntoBuffer(root);
      if (got === 0) break;
    }

    const appended = appendFromBuffer(root);

    // 0件なら終端
    if (appended === 0) {
      st.exhausted = true;
      hideButton(root);
      return;
    }

    // ここが重要：最後のページが perPage 未満でも、覗き見で確定させる
    await peekAndMaybeHide(root);
  }

  async function onClick(e) {
    const btn = e.target.closest("[data-load-more]");
    if (!btn) return;

    const root = btn.closest("[data-items-load-more]");
    if (!root) return;

    const st = getState(root);
    if (st.loading) return;

    setLoading(root, true);
    try {
      await loadMore(root);
    } finally {
      setLoading(root, false);
    }
  }

  function init() {
    document.querySelectorAll("[data-items-load-more]").forEach((root) => {
      const st = getState(root);
      st.page = 1;
      st.buffer = [];
      st.exhausted = false;
      st.loading = false;

      // 初期状態で覗き見しておく（初回が全件表示だったケースも消える）
      peekAndMaybeHide(root);
    });
  }

  document.addEventListener("click", onClick);
  document.addEventListener("DOMContentLoaded", init);
})();
